import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { FlexibleFileUploadComponent } from './flexible-file-upload/flexible-file-upload.component';
import { UserRoleServiceService } from './services/user-role-service.service';
import { ErrorLoggerService } from './services/error-logger.service';
import { NumericOnlyDirective } from './custom-directives/numeric-only.directive';
import { ExcelServiceService } from './services/excel-service.service';
import { UnauthorizedComponent } from '../Common/Components/unauthorized/unauthorized.component';
import { ConfigService } from './services/config.service';


@NgModule({
  declarations: [
    FlexibleFileUploadComponent,
    NumericOnlyDirective,
    UnauthorizedComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule
  ],
  exports: [
    FlexibleFileUploadComponent,
    UnauthorizedComponent
  ],
  providers:[
    UserRoleServiceService,
    ErrorLoggerService,
    ExcelServiceService,
    ConfigService
  ]
})
export class SharedModule { }
